import {
  TSemanticButtonVariant,
} from './semantic-button';

type TSemanticButtonLabelMap = Record<TSemanticButtonVariant, string>;

const english: TSemanticButtonLabelMap = {
  accept: 'Accept',
  add: 'Add',
  back: 'Back',
  cancel: 'Cancel',
  close: 'Close',
  create: 'Create',
  delete: 'Delete',
  edit: 'Edit',
  forward: 'Forward',
  reset: 'Reset',
  resetFilters: 'Reset filters',
  save: 'Save',
  saveAsNew: 'Save as ...',
  settings: 'Settings',
  tableNavigation: '',
  upload: 'Upload',
  calculate: 'Calculate',
  revision: 'Revision',
  fullscreen: 'Fullscreen',
  optionMenu: 'Additional functions',
  duplicate: 'Duplicate',
  refresh: 'Refresh',
  copy: 'Copy',
  download: 'Download',
  moveUp: 'Move up',
  moveDown: 'Move down',
};

export default english;
